import { createRestSlice } from "./restSlice";

export type EntrypointType = "phone" | "web" | "native";
export type EntrypointStatus = "active" | "disabled";

export interface PhoneEntrypointConfig {
  phoneNumber: string;
  telephonyId?: string;
  friendlyName?: string;
  areaCode?: string;
  countryCode?: string;
  direction?: "inbound" | "outbound" | "both";
}

export interface WebEntrypointConfig {
  allowedOrigins: string[];
  widgetConfig?: Record<string, unknown>;
}

export interface NativeEntrypointConfig {
  clientId: string;
  allowedApiKeyIds?: string[];
  clientSecretSecretId?: string;
}

export type EntrypointConfig = PhoneEntrypointConfig | WebEntrypointConfig | NativeEntrypointConfig;

export interface WeightedRelease {
  releaseId: string;
  weight: number;
}

export type Entrypoint = {
  id: string;
  organizationId: string;
  type: EntrypointType;
  name: string;
  status: EntrypointStatus;
  releases: WeightedRelease[];
  config: EntrypointConfig;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const entrypointSlice = createRestSlice<Entrypoint>("entrypoint", "/v1/entrypoints");

export const entrypointReducer = entrypointSlice.reducer;
export const entrypointActions = entrypointSlice.actions;
